import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { PatientInfoEditable, ResidentType } from 'pages/NewConfirmation/config';
import { CcrcModal } from 'widgets/Ccrc';
import { Modal } from 'shared/ui';
import { NotFoundPtModal } from 'shared/ui/Modal';
import ConfirmationService from 'legacy/api/ConfirmationService';
import PrivacyAgreeService from 'legacy/api/PrivacyAgreeService';
import { handleError } from 'legacy/config/Error';
import CheckFailModal from 'legacy/layouts/Modal/CheckFailModal';
import CommonModal from 'legacy/layouts/Modal/CommonModal';
import HCPModal from 'legacy/layouts/Modal/HCPModal';

import ChildrenCheck from './ChildrenCheck';
import InformationCheck from './InformationCheck';

const AgentAuthentication = () => {
  const { state } = useLocation();
  const hspId = state?.hspId;
  const usrId = state?.usrId;
  const userNm = state?.userNm;
  const userBirthday = state?.userBirthday;
  const sucsRedirectURL = state?.sucsRedirectURL;
  const failRedirectURL = state?.failRedirectURL;
  const failconnRedirectURL = state?.failconnRedirectURL;
  const rsvTp = state?.rsvTp;
  const telNo = state?.telNo;
  const nativeGb = state?.nativeGb;
  const sexTpCd = state?.sexTpCd;
  const hspCd = state?.hspCd;
  const ccrcReqId = state?.ccrcReqId;
  const rlnmUseYn = state?.rlnmUseYn;
  const ptNoCreAddrSndYn = state?.ptNoCreAddrSndYn;
  const ptInfoWrtPsbYn = state?.ptInfoWrtPsbYn;
  const failPatientRedirectURL = state?.failPatientRedirectURL;
  const guideUrl = state?.guideUrl;

  const numberName = nativeGb === ResidentType.Local ? '주민등록번호' : '외국인등록번호';

  const navigate = useNavigate();
  const [informationCheckBool, setInformationCheckBool] = useState(false);
  const [allRequireCheck, setAllRequireCheck] = useState(false);
  const [nameVerification, setNameVerification] = useState(false);

  const [userInfo, setUserInfo] = useState({ ptNm: '', ptRrn: '' });
  const [selYn, setSelYn] = useState('N');
  const [rspsRelTpCd, setRspsRelTpCd] = useState('');
  const [ccrcItemList, setCcrcItemList] = useState([]);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [commonModalMessageType, setCommonModalMessageType] = useState('');
  const [checkFailCount, setCheckFailCount] = useState(0);
  const [checkFailModalOpen, setCheckFailModalOpen] = useState(false);
  const [checkFailConnCount, setCheckFailConnCount] = useState(0);
  const [failMessage, setFailMessage] = useState('');
  const [hspNm, setHspNm] = useState('');
  const [errorModalData, setErrorModalData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [ccrcResultList, setCcrcResultList] = useState([]);
  const [showNewPtAddressModal, setShowNewPtAddressModal] = useState(false);
  const [showNewPtAddressCcrcItemList, setShowNewPtAddressCcrcItemList] = useState(false);
  // 주소 동의 시나리오일 경우 앞서 체크 했던 동의 항목과 결합시키기 위한 상태
  const [prevCcrcResultList, setPrevCcrcResultList] = useState([]);
  const isChildren = (rsvTp === '2' && rspsRelTpCd === '1') || rsvTp === '3';
  const [showPage, setShowPage] = useState(false);
  const [selfCheckBool, setSelfCheckBool] = useState(false);
  const [interfaceCommonYn, setInterfaceCommonYn] = useState(null);
  const [hspTel, setHspTel] = useState('');
  const [showCommonProcessErrorPopup, setShowCommonProcessErrorPopup] = useState(false);
  const [hspNvYn, setHspNvYn] = useState('');
  const setInitCcrcInputs = useBoundStore((state) => state['ccrcModal'].setInitCcrcInputs);

  useEffect(() => {
    if (informationCheckBool && nameVerification && rspsRelTpCd != '') {
      setAllRequireCheck(true);
    } else {
      setAllRequireCheck(false);
    }
  }, [informationCheckBool, nameVerification, rspsRelTpCd]);
  const fetchData = async () => {
    const param = {
      rsvTp: rsvTp,
      hspId,
      hspCd: hspCd,
    };

    await ConfirmationService.getPtcfmt(param)
      .then((response) => {
        if (response.status === 200) {
          setCcrcItemList(response.data.ccrcGuidDtoList);
          setHspNm(response.data.hspNm);
          setHspTel(response.data.hspTel);
          setInterfaceCommonYn(response.data.interfaceCommonYn);
          setShowModal(true);
          setShowPage(true);
          setHspNvYn(response.data.hspNvYn);
        }
      })
      .catch((error) => handleError(error));
  };

  useEffect(() => {
    if (rsvTp) {
      fetchData();
      if (rsvTp === '3') setRspsRelTpCd('1');
    }
  }, [rsvTp]);

  useEffect(() => {
    if (checkFailCount >= 4) {
      window.location.replace(decodeURIComponent(failRedirectURL));
    } else if (checkFailCount && checkFailCount < 4) {
      setCheckFailModalOpen(true);
    }
  }, [checkFailCount]);

  useEffect(() => {
    if (checkFailConnCount >= 2) {
      window.location.replace(decodeURIComponent(failconnRedirectURL));
    } else if (checkFailConnCount && checkFailConnCount < 2) {
      setCheckFailModalOpen(true);
    }
  }, [checkFailConnCount]);

  const onSubmit = () => {
    if (allRequireCheck) {
      const ccrcIdGroup = ccrcResultList.reduce(
        (pv, cv) => [...pv, { [cv.ccrcGuidId]: { ...cv, ccrcYn: cv.ccrcDspYn === 'N' ? 'Y' : cv.ccrcYn } }],
        [],
      );
      const rsvTpVal = rsvTp === '1' ? 'S' : rsvTp === '2' ? 'D' : 'CD';
      const resultList = Object.values([...ccrcIdGroup].reduce((pv, cv) => ({ ...pv, ...cv }), {}));

      setAllRequireCheck(false);

      const param = {
        usrId: usrId,
        rspsRelTpCd: rspsRelTpCd,
        ptNm: userInfo.ptNm,
        ptRrn: userInfo.ptRrn,
        chcProvCcrcYn: selYn,
        ccrcResultList: resultList,
        telNo: telNo,
        hspId,
        hspCd: hspCd,
        ccrcReqId,
        rsvTp: rsvTpVal,
        ptNoCreAddrSndYn,
        rlnmUseYn,
        hspNvYn,
      };
      if (interfaceCommonYn === 'Y') {
        ConfirmationService.postCommonPtcfmtcmpl({ ...param, nativeGb })
          .then((response) => {
            setAllRequireCheck(true);
            if (response.status === 200) {
              if (response.data.result === '0') {
                window.location.replace(decodeURIComponent(sucsRedirectURL));
              } else if (response.data.result === '1') {
                setCheckFailCount(() => checkFailCount + 1);
                setFailMessage(response.data.ityy);
                if (ptInfoWrtPsbYn === PatientInfoEditable.Editable) {
                  document.querySelector('#userName').disabled = false;
                  document.querySelector('#jumin1').disabled = false;
                  document.querySelector('#jumin2').disabled = false;
                  setSelfCheckBool(false);
                }
              } else if (response.data.result === '2') {
                setCheckFailConnCount(() => checkFailConnCount + 1);
                setFailMessage(response.data.ityy);
                if (ptInfoWrtPsbYn === PatientInfoEditable.Editable) {
                  document.querySelector('#userName').disabled = false;
                  document.querySelector('#jumin1').disabled = false;
                  document.querySelector('#jumin2').disabled = false;
                  setSelfCheckBool(false);
                }
              } else if (response.data.result === '3') {
                // 에러 팝업 케이스. 가로

                const { ityy: mainTitl, popUpButtonList } = response.data;
                setErrorModalData({ mainTitl, popUpButtonList });

                if (ptInfoWrtPsbYn === PatientInfoEditable.Editable) {
                  document.querySelector('#userName').disabled = false;
                  document.querySelector('#jumin1').disabled = false;
                  document.querySelector('#jumin2').disabled = false;
                  setSelfCheckBool(false);
                }
              } else if (response.data.result === '4') {
                setShowNewPtAddressModal(true);
              } else if (response.data.result === '5') {
                setShowCommonProcessErrorPopup(true);
              }
            }
          })
          .catch((error) => {
            setCheckFailCount(() => checkFailCount + 1);
            handleError(error);
          });
      } else {
        ConfirmationService.postPtcfmtcmpl(param)
          .then((response) => {
            setAllRequireCheck(true);
            if (response.status === 200) {
              if (response.data.result === '0') {
                window.location.replace(decodeURIComponent(sucsRedirectURL));
              } else if (response.data.result === '1') {
                setCheckFailCount(() => checkFailCount + 1);
                setFailMessage(response.data.ityy);
                if (ptInfoWrtPsbYn === PatientInfoEditable.Editable) {
                  document.querySelector('#userName').disabled = false;
                  document.querySelector('#jumin1').disabled = false;
                  document.querySelector('#jumin2').disabled = false;
                  setSelfCheckBool(false);
                }
              } else if (response.data.result === '2') {
                setCheckFailConnCount(() => checkFailConnCount + 1);
                setFailMessage(response.data.ityy);
                if (ptInfoWrtPsbYn === PatientInfoEditable.Editable) {
                  document.querySelector('#userName').disabled = false;
                  document.querySelector('#jumin1').disabled = false;
                  document.querySelector('#jumin2').disabled = false;
                  setSelfCheckBool(false);
                }
              } else if (response.data.result === '3') {
                // 에러 팝업 케이스. 가로

                const { ityy: mainTitl, popUpButtonList } = response.data;
                setErrorModalData({ mainTitl, popUpButtonList });

                if (ptInfoWrtPsbYn === PatientInfoEditable.Editable) {
                  document.querySelector('#userName').disabled = false;
                  document.querySelector('#jumin1').disabled = false;
                  document.querySelector('#jumin2').disabled = false;
                  setSelfCheckBool(false);
                }
              } else if (response.data.result === '4') {
                setShowNewPtAddressModal(true);
              }
            }
          })
          .catch((error) => {
            setCheckFailCount(() => checkFailCount + 1);
            handleError(error);
          });
      }
    }
  };

  const openModal2 = (messageType) => {
    setModalOpen2(true);
    setCommonModalMessageType(messageType);
  };

  const closeModal2 = () => {
    setModalOpen2(false);
    setCommonModalMessageType('');
  };

  const handleCloseCheckFailModal = () => {
    setCheckFailModalOpen(false);
  };

  return (
    showPage && (
      <Fragment>
        <div className='content-article btn-fixed' role='article'>
          <div className='inner-content info-check'>
            <h3 className='tit_g tit_type6'>
              환자 정보 확인을 위해
              <br />
              {numberName}를 입력해주세요
            </h3>
            <p className='tit_label'>걱정마세요. 개인 정보는 병원을 통한 환자정보 조회에만 사용돼요.</p>

            {(rsvTp === '2' || rsvTp === '3') && (
              <InformationCheck
                rsvTp={rsvTp}
                rspsRelTpCd={rspsRelTpCd}
                setRspsRelTpCd={setRspsRelTpCd}
                setInformationCheckBool={setInformationCheckBool}
                setNameVerification={setNameVerification}
                setUserInfo={setUserInfo}
                sexTpCd={sexTpCd}
                userNm={userNm}
                nativeGb={nativeGb}
                userBirthday={userBirthday}
                openModal2={openModal2}
                onSubmit={onSubmit}
                selfCheckBool={selfCheckBool}
                setSelfCheckBool={setSelfCheckBool}
                interfaceCommonYn={interfaceCommonYn}
              />
            )}

            {isChildren && <ChildrenCheck guideUrl={guideUrl} />}

            <div className='agree-terms'>
              <p>
                본 안내문은 개인정보 보호법 제20조(정보주체 이외로부터 수집한 개인정보의 수집 출처 등 고지) 및 동법
                시행령 제15조의2(개 인정보 수집 출처 등 고지 대상·방법·절차)에 따라 개인정보 수집 출처 및 내역을 안내
                드립니다.
              </p>

              <div className='agree-main'>
                <p>{hspNm}은 아래와 같이 개인정보를 수집하였습니다.</p>
                <dl>
                  <dt>수집출처</dt>
                  <dd>카카오헬스케어 케어챗 회원가입</dd>
                </dl>
                <dl>
                  <dt>처리목적</dt>
                  <dd>카카오헬스케어 케어챗 서비스 제공과 관리</dd>
                </dl>
              </div>

              <p>
                고객님께서는 개인정보보호법 제37조(개인정보의 처리정지 등) 에 따라 고객님의 개인정보를 처리하는 것에
                대해 정지를 당사 및 업체로 요구할 수 있는 권리가 있습니다. 회원탈퇴를 하신 경우 고 객님의 개인정보는
                관련 법령 및 개인정보처리방침에 따라 처리됩 니다. 개인정보 처리정지를 요청하실 경우 서비스 이용이 제한
                될 수 있습니다.
              </p>
            </div>
          </div>

          <div className='btm-content full gap-round'>
            <button
              type='button'
              className={'btn_g btn_primary' + (allRequireCheck ? ' btn_highlight' : '')}
              disabled={!allRequireCheck}
              onClick={() => {
                if (interfaceCommonYn === 'N' && rlnmUseYn === 'N') {
                  document.getElementById('rlnm-check-btn').click();
                } else {
                  onSubmit();
                }
              }}
              style={{ zIndex: showModal ? 0 : 200 }}
            >
              완료
            </button>
          </div>
        </div>
        {showModal && (
          <CcrcModal
            header={hspNm}
            title={showNewPtAddressCcrcItemList ? '주소 수집·이용에 동의해주세요' : '동의를 진행해주세요'}
            desc={
              showNewPtAddressCcrcItemList
                ? `걱정마세요. 소중한 주소 정보는 검진결과서 외 우편물을 발송하거나, 응급상황 시 인근 병원으로의 호송 등을 위해 진료 기록부 관리 목적으로 활용되며, 병원에서 안전하게 보관됩니다.`
                : `${hspNm}의 정보 수집 동의를 포함하고 있습니다. 이에 대한 동의는 거부할 수 있으며, 거부 시 서비스이용이 제한될 수 있습니다.`
            }
            hspCd={hspCd}
            hspId={hspId}
            ccrcItemList={ccrcItemList}
            handleClick={(resultList) => {
              if (showNewPtAddressCcrcItemList) {
                navigate('/newPtAddress', {
                  replace: true,
                  state: {
                    usrId,
                    rspsRelTpCd,
                    rsvTp,
                    ptNm: userInfo.rPtNm,
                    ptRrn: userInfo.rPtRrn,
                    maskPtRrn: userInfo.maskPtRrn,
                    telNo,
                    hspId,
                    hspCd,
                    ccrcResultList: [...prevCcrcResultList, ...resultList],
                    sucsRedirectURL,
                    failRedirectURL,
                    failconnRedirectURL,
                    ccrcReqId,
                    interfaceCommonYn,
                  },
                });
              }
              setShowModal(false);
              setCcrcResultList(resultList);
            }}
          />
        )}
        {showNewPtAddressModal && (
          <Modal
            title={
              <>
                {userInfo.rPtNm}님은 병원에 등록된
                <br />
                환자정보가 없어요
              </>
            }
            contents={
              <>
                아직 {hspNm}에서 진료를 받은 적이 없으시네요.
                <br />
                병원에 환자 정보를 등록하기 위해서는 주소를 입력해주셔야 해요.
              </>
            }
            close={async () => {
              const { data } = await PrivacyAgreeService.myMenuCcrcThrd({
                hspId,
                hspCd,
                usrId,
                ccrcTp: 'ADDR',
              });
              const addressCcrcItemList = data.reduce((pv, cv) => {
                return [...pv, { ...cv, ccrcDspYn: 'Y', ccrcDtlYn: 'Y', essnYn: 'Y' }];
              }, []);
              setInitCcrcInputs({});
              setPrevCcrcResultList(ccrcResultList);
              setCcrcItemList(addressCcrcItemList);
              setShowNewPtAddressModal(false);
              setShowNewPtAddressCcrcItemList(true);
              setShowModal(true);
            }}
          />
        )}
        <CommonModal open2={modalOpen2} close2={closeModal2} messageType={commonModalMessageType} />
        <CheckFailModal open={checkFailModalOpen} onClose={handleCloseCheckFailModal} content={failMessage} />
        {errorModalData && <HCPModal cpModalData={errorModalData} closeCpModal={() => setErrorModalData(null)} />}
        {showCommonProcessErrorPopup && (
          <NotFoundPtModal
            hspNm={hspNm}
            hspTel={hspTel}
            close={() => {
              window.location.href = failPatientRedirectURL;
            }}
          />
        )}
      </Fragment>
    )
  );
};
export default AgentAuthentication;
